<section class="permissions-page">
  <div class="page-heading">
    <div>
      <p>Business access</p>
      <h2>Role permissions</h2>
      <small>A business can delegate only features enabled for its owner subscription.</small>
      @if (selectedRole?.isSystemRole) { <small>The root Super Admin role is protected.</small> }
    </div>
    <button
      type="button"
      (click)="save()"
      [disabled]="!canAssignPermissions || isSaving || isLoading || isRoleLoading || !selectedRoleId"
    >
      <span class="material-symbols-outlined" aria-hidden="true">save</span
      >{{ isSaving ? 'Saving...' : canAssignPermissions ? 'Save changes' : 'View only' }}
    </button>
  </div>
  @if (isPlatformAdmin) {
    <section class="access-scope">
      <div><strong>Platform administration roles</strong><small>Permissions apply only to ZepBazaar platform administrators. Business roles are managed inside each business.</small></div>
    </section>
  }
  @if (isLoading) {
    <p class="state">Loading roles and permissions...</p>
  }
  @if (successMessage) {
    <p class="state success">{{ successMessage }}</p>
  }
  @if (errorMessage) {
    <p class="state error">{{ errorMessage }}</p>
  }
  @if (!isLoading) {
    <section class="role-selector">
      <label for="permission-role">Select role</label>
      <select
        id="permission-role"
        [(ngModel)]="selectedRoleId"
        (ngModelChange)="loadRolePermissions()"
      >
        @for (role of roles; track role.id) {
          <option [value]="role.id">{{ role.name }}</option>
        }
      </select>
      <span>{{ selectedPermissionIds.size }} permissions enabled</span>
    </section>
    @if (isRoleLoading) {
      <p class="state">Loading selected role access...</p>
    }
    <section class="permission-grid" [class.busy]="isRoleLoading">
      @for (module of modules; track module) {
        <article>
          <header>
            <span class="material-symbols-outlined">lock_open</span>
            <div class="module-copy">
              <h3>{{ module }}</h3>
              <small>{{ moduleSelectedCount(module) }} of {{ permissionsFor(module).length }} selected</small>
            </div>
            <button
              class="module-toggle"
              type="button"
              [class.clear]="isModuleFullySelected(module)"
              [disabled]="!canAssignPermissions || isRoleLoading"
              (click)="toggleModule(module)"
            >
              <span class="material-symbols-outlined">{{ isModuleFullySelected(module) ? 'remove_done' : 'done_all' }}</span>
              {{ isModuleFullySelected(module) ? 'Clear all' : 'Select all' }}
            </button>
          </header>
          <div class="permission-list">
            @for (permission of permissionsFor(module); track permission.id) {
              <label
                ><input
                  type="checkbox"
                  [checked]="selectedPermissionIds.has(permission.id)"
                  [disabled]="!canAssignPermissions || isRoleLoading"
                  (change)="toggle(permission.id, $any($event.target).checked)"
                /><span
                  ><strong>{{ permission.name }}</strong
                  ><small>{{ permission.description || permission.code }}</small></span
                ></label
              >
            }
          </div>
        </article>
      } @empty {
        <p class="state error">No subscription permissions are available.</p>
      }
    </section>
  }
</section>
